import React from 'react';

const Loading: React.FC = () => {
  return null;
};

export default Loading;
